export default {
    eos_endpoint: 'https://api-kylin.eoslaomao.com',
    put_endpoint: 'https://uzjsc1e8d6.execute-api.us-east-1.amazonaws.com/staging',
    items_for_sale: {
        storage: 596724,
        cpu: 596723
    }
}